import React from "react";
import Overlay from "react-bootstrap/Overlay";
import Popover from "react-bootstrap/Popover";
import Button from "react-bootstrap/Button";
import store from "../../store";
import {toggleInfoTooltips} from "../../actions/userActions";
import {withRouter} from "react-router-dom";
import connect from "react-redux/es/connect/connect";
import {allTooltips} from "../../lib/constants";

const Translate = require('react-redux-i18n').Translate;


const stateMap = (store) => {
    return {
        userReducer: store.userReducer,
    };
};


class Tooltip extends React.Component {

    constructor(props) {
        super(props)
        this.state = {
            showTooltip: false,
            target: null
        };
        this.toggleTooltip = this.toggleTooltip.bind(this);
        this.overlayContainerRef = React.createRef();
    }


    toggleTooltip(tltp) {
        store.dispatch(toggleInfoTooltips("showInfo__" + tltp.replace(/-/g, "_"), !this.props.userReducer["showInfo__" + tltp.replace(/-/g, "_")]));
        allTooltips.forEach(elProp => {
            if (elProp !== tltp && this.props.userReducer["showInfo__" + elProp.replace(/-/g, "_")]) {
                store.dispatch(toggleInfoTooltips("showInfo__" + elProp.replace(/-/g, "_"), false))
            }
        })
    }


    render() {
        let show = this.props.userReducer["showInfo__" + this.props.popoverId.replace(/-/g, "_")];
        let prefix = "tooltips.click.";
        return (
            <label htmlFor={this.props.tooltipButtonId}
                   className={this.props.tooltipLabelClass}
                   ref={this.overlayContainerRef}>
                <Button id={this.props.tooltipButtonId}
                        className="tooltip-button"
                        onClick={e => {
                            this.toggleTooltip(this.props.popoverId)
                            this.setState({
                                target: e.target,
                            });
                        }}>
                </Button>
                <span className="icon-icon-info"/>
                <Overlay
                    show={show}
                    target={this.state.target}
                    placement={this.props.placement}
                    container={this.overlayContainerRef}
                    containerPadding={20}>
                    <Popover id={this.props.popoverId}
                             title=''>
                        <article className="popover-content">
                            {this.props.dangerousHtml ?
                                <Translate value={prefix + this.props.tooltipText} dangerousHTML/> :
                                <Translate value={prefix + this.props.tooltipText}/>}
                        </article>
                    </Popover>
                </Overlay>
            </label>
        )
    }
}

export default withRouter(connect(stateMap)(Tooltip));

